export default "__VITE_ASSET__BgVW$5LR__"